import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
} from '@resy/ui-kitchen';
import AmexGDAOffersBenefitCard from '../AmexGDAOffersBenefitCard';
import AmexGDAOffersTerms from '../AmexGDAOffersTerms';
import AmexGDAOffersApplyNow from '../AmexGDAOffersApplyNow';
import './AmexGDAOffersBenefits.scss';

const AmexGDAOffersBenefits = (props) => {
  const {
    amexCardData: {
      benefitArrayReOrdered,
    },
    resyCardData: {
      iconMappings,
      hideLinkLabel,
    },
    baseRequestUrl,
    isDesktopMedia,
    Analytics,
    clickShowDetails,
  } = props;

  const renderBenefitsArray = () => benefitArrayReOrdered.map((item) => {
    const {
      title, sequence_order: sequenceOrder, display_text: displayText, metadata_list: metadataList,
    } = item;

    let iconNameValue = '';
    let iconNameText = '';

    if (metadataList) {
      const metadataIcon = metadataList.filter((metadata) => metadata.name === 'IconName');
      const metadataNew = metadataList.filter((metadata) => metadata.name === 'NewLabel');

      if (metadataNew && metadataNew[0]) {
        iconNameText = metadataNew[0].value;
      }
      if (metadataIcon && metadataIcon[0]) {
        const iconNameArr = iconMappings.filter((icon) => icon.name === metadataIcon[0].value);
        if (iconNameArr && iconNameArr[0]) {
          iconNameValue = iconNameArr[0].path;
        }
      }
    }

    if (iconNameValue === '') {
      iconNameValue = 'star.svg';
    }

    if (isDesktopMedia) {
      return (
        <div className="col-sm-6 col-lg-4">
          <AmexGDAOffersBenefitCard
            title={title}
            key={sequenceOrder}
            displayText={displayText[0] ? displayText[0].text : ''}
            iconName={iconNameValue}
            newText={iconNameText}
            baseRequestUrl={baseRequestUrl}
          />
        </div>
      );
    }
    return (
      <AmexGDAOffersBenefitCard
        title={title}
        key={sequenceOrder}
        displayText={displayText[0] ? displayText[0].text : ''}
        iconName={iconNameValue}
        newText={iconNameText}
        baseRequestUrl={baseRequestUrl}
      />
    );
  });

  if (isDesktopMedia) {
    return (
      <section className="AmexGDAOffersBenefits AmexGDAOffersBenefits__show">
        <article className="AmexGDAOffersBenefits__gdawrapper main-content">
          <div className="row">
            {renderBenefitsArray(isDesktopMedia)}
          </div>
          <div className="AmexGDAOffersBenefits__gdawrapper__footer">
            <AmexGDAOffersTerms
              {...props}
              Analytics={Analytics}
            />
            <AmexGDAOffersApplyNow
              {...props}
              Analytics={Analytics}
            />
          </div>
          <div className="AmexGDAOffersBenefits__bottom">
            <Button
              variant="no-style"
              className="AmexGDAOffersBenefits__bottom-hide-link"
              type="button"
              aria-expanded="true"
              onClick={() => {
                clickShowDetails('#platinumoffer');
              }}
            >
              {hideLinkLabel}
            </Button>
          </div>
        </article>
      </section>
    );
  }
  return (
    <div className="AmexGDAOffersBenefits__benefits">
      <div className="AmexGDAOffersBenefits__benefits__cards">
        <div className="AmexGDAOffersBenefits__benefits__cards-grid">
          {renderBenefitsArray(isDesktopMedia)}
        </div>
      </div>
    </div>
  );
};

AmexGDAOffersBenefits.propTypes = {
  Analytics: PropTypes.shape({
    event: PropTypes.func,
  }).isRequired,
  amexCardData: PropTypes.shape(PropTypes.shape().isRequired).isRequired,
  resyCardData: PropTypes.shape(PropTypes.shape().isRequired).isRequired,
  baseRequestUrl: PropTypes.string.isRequired,
  clickShowDetails: PropTypes.func.isRequired,
  isDesktopMedia: PropTypes.bool.isRequired,
};
export default AmexGDAOffersBenefits;
